/**
 * Resolves a schema value that can be either static or a `(ctx) => value` resolver.
 *
 * @param {*} value - static value or resolver function
 * @param {Object} ctx - table context provided by the view (fields, groupBy, isFetching…)
 * @return {*} the resolved value
 */
const resolveValue = (value, ctx) => (typeof value === 'function' ? value(ctx) : value);

export default resolveValue;
